import { requests } from '@/libs/axios/axios'
import { LicenseEndpoints } from '../license-endpoints'

async function cancelLicense(id: number) {
  return requests.post(`${LicenseEndpoints.LICENSE}/${id}/cancel`, {})
}

export default cancelLicense
